/**
 * Espace de noms `crm` — Horevia CRM (ADR-025) : vue d'ensemble, clients 360,
 * fidélité, segments, relances, consentements, doublons, réglages, caisse.
 */
export const crmFr = {
  title: 'CRM',
  noModule: 'Le module Horevia CRM n’est pas actif sur cet établissement.',
  overview: {
    title: 'Vue d’ensemble',
    subtitle: 'Connaître et fidéliser : qui vient, qui revient, qui dépense, qui mérite un mot.',
  },
  customers: {
    title: 'Clients',
    subtitle: 'Vue 360 : visites, dépenses, fidélité et consentements, tous modules confondus.',
    search: 'Rechercher un client (nom, téléphone, e-mail)',
    empty: 'Aucun client ne correspond à ces critères.',
    loadMore: 'Afficher plus',
    columns: {
      customer: 'Client',
      activity: 'Activité',
      visits: 'Visites',
      spend: 'Dépense',
      lastVisit: 'Dernière visite',
      loyalty: 'Fidélité',
      consents: 'Accords',
    },
    filters: {
      activity: 'Activité',
      allActivities: 'Toutes',
      segment: 'Segment',
      allSegments: 'Tous les clients',
      sort: 'Trier par',
      kind: 'Nature',
      allKinds: 'Personnes et entreprises',
    },
    visitsDetail: '{{stays}} séjour(s) · {{orders}} commande(s)',
  },
  activity: { NEW: 'Nouveau', ACTIVE: 'Actif', INACTIVE: 'Inactif', NONE: 'Jamais venu' },
  sort: {
    spend: 'Dépense',
    lastVisit: 'Dernière visite',
    visits: 'Visites',
    name: 'Nom',
    points: 'Points',
  },
  kpi: {
    known: 'Clients connus',
    active: 'Actifs sur la période',
    new: 'Nouveaux',
    returning: 'Revenants',
    identifiedShare: 'Ventes rattachées à un client',
    identifiedShareFoot: 'part des commandes de la période',
    visits: 'Visites',
    spendTotal: 'Dépense totale',
    averageTicket: 'Ticket moyen',
    averageStay: 'Séjour moyen',
    lastVisit: 'Dernière visite',
    firstVisit: 'Première visite',
    members: 'Membres',
    earned: 'Points acquis',
    redeemed: 'Points utilisés',
    birthdays: 'Anniversaires à venir',
    birthdaysFoot: 'dans les {{count}} prochains jours',
    inactive: 'Clients inactifs',
    inactiveFoot: 'sans visite depuis {{count}} jours',
  },
  sections: {
    spendByModule: 'Dépenses des clients identifiés',
    topCustomers: 'Meilleurs clients',
    consents: 'Consentements accordés',
    loyalty: 'Fidélité',
    byTier: 'Répartition par palier',
    spendByYear: 'Dépenses par année',
    favorites: 'Habitudes',
    favoriteOutlet: 'Point de vente favori',
    topProducts: 'Produits préférés',
    recentStays: 'Derniers séjours',
    recentOrders: 'Dernières commandes',
    timeline: 'Chronologie',
    interactions: 'Contacts',
    account: 'Compte de fidélité',
    profile: 'Profil',
    followUps: 'À relancer',
  },
  columns: {
    year: 'Année',
    amount: 'Montant',
    product: 'Produit',
    quantity: 'Quantité',
    reference: 'Référence',
    resource: 'Logement',
    arrival: 'Arrivée',
    departure: 'Départ',
    nights: 'Nuits',
    total: 'Total',
    outlet: 'Point de vente',
    date: 'Date',
    status: 'Statut',
    channel: 'Canal',
    granted: 'Accordé',
    kind: 'Nature',
    context: 'Contexte',
    outcome: 'Résultat',
    by: 'Par',
    points: 'Points',
    type: 'Type',
    reason: 'Motif',
    source: 'Source',
  },
  detail: {
    subtitle: 'Vue 360 : chaque vente comptée une fois, hébergement hors folio.',
    openRecord: 'Ouvrir la fiche',
    noSpend: 'Aucune dépense enregistrée.',
    noStays: 'Aucun séjour.',
    noOrders: 'Aucune commande rattachée.',
  },
  timeline: {
    kinds: {
      STAY: 'Séjour',
      ORDER: 'Commande',
      PAYMENT: 'Paiement',
      LOYALTY: 'Fidélité',
      INTERACTION: 'Contact',
      CONSENT: 'Consentement',
    },
    loadMore: 'Événements précédents',
    empty: 'Aucun événement.',
  },
  loyalty: {
    title: 'Fidélité',
    subtitle: 'Programme à points et paliers : barème, valeur du point, avantages.',
    program: 'Programme',
    noProgram: 'Aucun programme de fidélité',
    noProgramBody:
      'Créez le programme : un point par tranche de vente, une valeur à l’utilisation, des paliers et leurs avantages. Rien n’est crédité avant la date de début.',
    inactiveNotice: 'Le programme est inactif : aucune vente ne rapporte de points.',
    balance: 'Solde',
    points_one: '{{count}} point',
    points_other: '{{count}} points',
    tier: 'Palier',
    noTier: 'Aucun palier',
    nextTier: 'Prochain palier : {{name}} dans {{count}} points',
    topTier: 'Palier le plus élevé atteint',
    benefits: 'Avantages',
    balanceValue: 'Valeur du solde',
    earnedTotal: 'Acquis à vie',
    redeemedTotal: 'Utilisés à vie',
    transactions: 'Journal des points',
    noTransactions: 'Aucune écriture.',
    adjust: 'Ajuster les points',
    adjustTitle: 'Créditer ou débiter des points',
    adjustHint: 'Un nombre négatif débite. Le motif est obligatoire et audité.',
    adjustPoints: 'Points',
    adjustReason: 'Motif',
    adjusted: 'Points ajustés : nouveau solde {{balance}}.',
    redeem: 'Utiliser des points',
    redeemTitle: 'Utiliser des points',
    redeemHint: 'Le débit est consigné ; la remise est appliquée par les outils habituels.',
    redeemPoints: 'Points à utiliser',
    redeemed: 'Points utilisés : nouveau solde {{balance}}.',
    types: {
      EARN: 'Acquis',
      REDEEM: 'Utilisés',
      ADJUST: 'Ajustement',
      REVERSAL: 'Contre-passation',
    },
    basis: { LIFETIME: 'À vie', ROLLING: 'Fenêtre glissante' },
    fields: {
      name: 'Nom du programme',
      isActive: 'Programme actif',
      isActiveHint: 'Inactif, aucune vente ne rapporte de points.',
      startsOn: 'Date de début',
      startsOnHint: 'Rien n’est crédité pour une vente antérieure.',
      pointsPerStep: 'Points par tranche',
      stepAmount: 'Montant de la tranche',
      pointValue: 'Valeur d’un point',
      pointValueHint: 'Montant déduit par point utilisé à la caisse.',
      earnOnHotel: 'Les séjours rapportent',
      earnOnPos: 'Les commandes rapportent',
      includeCompanies: 'Les entreprises cumulent',
      tierBasis: 'Base des paliers',
      tierWindowMonths: 'Fenêtre (mois)',
      tiers: 'Paliers',
      tierCode: 'Code',
      tierName: 'Nom',
      tierMinPoints: 'Seuil (points)',
      tierBenefits: 'Avantages (un par ligne)',
      addTier: 'Ajouter un palier',
      removeTier: 'Retirer',
      summary: '{{points}} point(s) par tranche de {{step}} · 1 point = {{value}}',
    },
    save: 'Enregistrer le programme',
    saved: 'Programme enregistré.',
    orderRedeem: {
      title: 'Points de fidélité',
      available: 'Solde : {{points}} points ({{value}})',
      points: 'Points à utiliser',
      apply: 'Appliquer la remise',
      applied: 'Remise « Fidélité » de {{amount}} appliquée.',
      alreadyDiscounted: 'La commande porte déjà une remise.',
      noProgram: 'Aucun programme actif.',
    },
  },
  segments: {
    title: 'Segments',
    subtitle: 'Critères déclaratifs, effectif calculé à la lecture, liste d’action en un clic.',
    new: 'Nouveau segment',
    edit: 'Modifier le segment',
    name: 'Nom',
    description: 'Description',
    active: 'Actif',
    members: 'Membres',
    membersCount_one: '{{count}} client',
    membersCount_other: '{{count}} clients',
    preview: 'Effectif estimé : {{count}}',
    save: 'Enregistrer',
    saved: 'Segment enregistré.',
    delete: 'Supprimer',
    deleteTitle: 'Supprimer ce segment ?',
    deleteBody: 'Les clients ne sont pas touchés : seul le critère disparaît.',
    deleted: 'Segment supprimé.',
    empty: 'Aucun segment. Créez-en un pour cibler vos habitués, vos entreprises ou vos inactifs.',
    openList: 'Voir les clients',
    followUp: 'Relancer',
    criteria: {
      title: 'Critères (cumulatifs)',
      kinds: 'Nature',
      tags: 'Étiquettes (séparées par des virgules)',
      tierCodes: 'Paliers (codes, séparés par des virgules)',
      minVisits: 'Visites minimum',
      minSpend: 'Dépense minimum',
      periodMonths: 'Sur les derniers (mois)',
      lastVisitBefore: 'Dernière visite avant le',
      lastVisitAfter: 'Dernière visite après le',
      inactiveDays: 'Inactif depuis (jours)',
      birthdayMonths: 'Mois d’anniversaire (1 → 12, séparés par des virgules)',
      consent: 'Consentement',
      consentAny: 'Indifférent',
      consentGranted: 'Accordé pour {{channel}}',
      consentDenied: 'Absent ou retiré pour {{channel}}',
      modules: 'A fréquenté',
      hotel: 'L’hébergement',
      pos: 'Les points de vente',
    },
  },
  followUps: {
    title: 'Relances',
    subtitle: 'Listes d’action : qui contacter, par quel canal, avec quel message.',
    kinds: {
      BIRTHDAYS: 'Anniversaires',
      INACTIVE: 'Inactifs',
      NO_CONSENT: 'Sans consentement',
      SEGMENT: 'Segment',
    },
    segment: 'Segment',
    pickSegment: 'Choisir un segment',
    columns: {
      customer: 'Client',
      date: 'Date',
      lastVisit: 'Dernière visite',
      spend: 'Dépense',
      loyalty: 'Fidélité',
      consents: 'Accords',
      lastContact: 'Dernier contact',
      actions: 'Actions',
    },
    whatsapp: 'WhatsApp',
    call: 'Appeler',
    email: 'E-mail',
    log: 'Consigner',
    empty: 'Personne à relancer dans cette liste.',
    template: 'Message proposé',
    noTemplate: 'Aucun modèle actif pour ce contexte : ajoutez-en un dans les réglages.',
    consentMissing: 'Sans accord pour ce canal',
    total_one: '{{count}} client',
    total_other: '{{count}} clients',
  },
  interactions: {
    title: 'Contacts',
    log: 'Consigner un contact',
    logTitle: 'Consigner un contact',
    kind: 'Nature',
    context: 'Contexte',
    subject: 'Objet',
    body: 'Détail',
    outcome: 'Résultat',
    empty: 'Aucun contact consigné.',
    saved: 'Contact consigné.',
    kinds: {
      CALL: 'Appel',
      WHATSAPP: 'WhatsApp',
      EMAIL: 'E-mail',
      SMS: 'SMS',
      VISIT: 'Visite',
      NOTE: 'Note',
      OTHER: 'Autre',
    },
    contexts: {
      BIRTHDAY: 'Anniversaire',
      INACTIVE: 'Relance inactif',
      SEGMENT: 'Segment',
      MANUAL: 'Manuel',
      SERVICE: 'Service',
    },
  },
  messages: {
    send: 'Envoyer un e-mail',
    title: 'Envoyer un e-mail',
    template: 'Modèle',
    freeText: 'Texte libre',
    subject: 'Objet',
    body: 'Message',
    hint: 'Variables : {{prenom}}, {{nom}}, {{nom_complet}}, {{points}}, {{palier}}, {{etablissement}}, {{derniere_visite}}.',
    sent: 'E-mail envoyé à {{to}}.',
    notSent: 'E-mail non envoyé (messagerie désactivée) ; le contact est tout de même consigné.',
    noEmail: 'Ce client n’a pas d’adresse e-mail.',
    consentRequired: 'Ce client n’a pas donné son accord pour les e-mails.',
  },
  consents: {
    title: 'Consentements',
    hint: 'Aucune sollicitation commerciale sans accord enregistré pour le canal.',
    channels: { EMAIL: 'E-mail', SMS: 'SMS', WHATSAPP: 'WhatsApp', PHONE: 'Téléphone' },
    granted: 'Accordé',
    revoked: 'Retiré',
    never: 'Non renseigné',
    on: 'le {{date}}',
    grant: 'Enregistrer l’accord',
    revoke: 'Enregistrer le retrait',
    recorded: 'Consentement enregistré.',
    sourceLabel: 'Recueilli',
    sources: {
      IN_PERSON: 'En personne',
      PHONE: 'Par téléphone',
      FORM: 'Par formulaire',
      IMPORT: 'Import',
      OTHER: 'Autre',
    },
    history: 'Historique des consentements',
  },
  merge: {
    action: 'Fusionner un doublon',
    title: 'Fusionner un doublon dans cette fiche',
    description:
      'La fiche choisie est absorbée : ses séjours, commandes, factures, paiements, documents, points, consentements et contacts passent sur cette fiche ; elle est ensuite archivée. Irréversible.',
    pick: 'Fiche à absorber',
    pickPlaceholder: 'Rechercher le doublon',
    confirm: 'Fusionner',
    done: 'Fiches fusionnées.',
    mergedInto: 'Cette fiche a été fusionnée dans une autre.',
    openTarget: 'Ouvrir la fiche conservée',
  },
  duplicates: {
    title: 'Doublons probables',
    subtitle:
      'Même téléphone, même e-mail ou même nom et date de naissance : à fusionner depuis la fiche à conserver.',
    criterion: { PHONE: 'Téléphone', EMAIL: 'E-mail', NAME_BIRTHDATE: 'Nom et date de naissance' },
    empty: 'Aucun doublon probable.',
    visits_one: '{{count}} visite',
    visits_other: '{{count}} visites',
    createdAt: 'Créée le {{date}}',
  },
  settings: {
    title: 'Réglages CRM',
    subtitle: 'Fenêtres d’anniversaire et d’inactivité, modèles de message.',
    inactiveAfterDays: 'Inactif après (jours)',
    birthdayWindowDays: 'Anniversaires à venir (jours)',
    save: 'Enregistrer',
    saved: 'Réglages enregistrés.',
    templates: 'Modèles de message',
    newTemplate: 'Nouveau modèle',
    editTemplate: 'Modifier le modèle',
    template: {
      code: 'Code',
      name: 'Nom',
      channel: 'Canal',
      context: 'Contexte',
      subject: 'Objet',
      body: 'Texte',
      isActive: 'Actif',
    },
    channels: { ANY: 'Tous canaux', EMAIL: 'E-mail', WHATSAPP: 'WhatsApp', SMS: 'SMS' },
    templatesEmpty: 'Aucun modèle : les listes d’action ne proposeront pas de message.',
    deleteTemplate: 'Supprimer',
    deleteTemplateTitle: 'Supprimer ce modèle ?',
    deleted: 'Modèle supprimé.',
    templateSaved: 'Modèle enregistré.',
  },
  pos: {
    customer: 'Client',
    attach: 'Rattacher un client',
    change: 'Changer de client',
    detach: 'Retirer le client',
    none: 'Sans client',
    attached: 'Client rattaché.',
    detached: 'Client retiré.',
    filterCustomer: 'Client',
    tierPoints: '{{tier}} · {{points}} pts',
    pointsOnly: '{{points}} pts',
  },
  card: {
    title: 'Clientèle',
    foot: 'sur la période',
    open: 'Ouvrir le CRM',
  },
  channels: { ANY: 'Tous', EMAIL: 'E-mail', WHATSAPP: 'WhatsApp', SMS: 'SMS', PHONE: 'Téléphone' },
  actions: {
    openCustomer: 'Voir le client',
    openCrm: 'Vue 360',
    openReport: 'Ouvrir le rapport',
  },
} as const;

export const crmEn = {
  title: 'CRM',
  noModule: 'The Horevia CRM module is not active for this property.',
  overview: {
    title: 'Overview',
    subtitle: 'Know and retain: who comes, who returns, who spends, who deserves a word.',
  },
  customers: {
    title: 'Customers',
    subtitle: '360° view: visits, spend, loyalty and consents across all modules.',
    search: 'Search a customer (name, phone, e-mail)',
    empty: 'No customer matches these criteria.',
    loadMore: 'Load more',
    columns: {
      customer: 'Customer',
      activity: 'Activity',
      visits: 'Visits',
      spend: 'Spend',
      lastVisit: 'Last visit',
      loyalty: 'Loyalty',
      consents: 'Consents',
    },
    filters: {
      activity: 'Activity',
      allActivities: 'All',
      segment: 'Segment',
      allSegments: 'All customers',
      sort: 'Sort by',
      kind: 'Kind',
      allKinds: 'People and companies',
    },
    visitsDetail: '{{stays}} stay(s) · {{orders}} order(s)',
  },
  activity: { NEW: 'New', ACTIVE: 'Active', INACTIVE: 'Inactive', NONE: 'Never came' },
  sort: {
    spend: 'Spend',
    lastVisit: 'Last visit',
    visits: 'Visits',
    name: 'Name',
    points: 'Points',
  },
  kpi: {
    known: 'Known customers',
    active: 'Active over the period',
    new: 'New',
    returning: 'Returning',
    identifiedShare: 'Sales linked to a customer',
    identifiedShareFoot: 'share of orders over the period',
    visits: 'Visits',
    spendTotal: 'Total spend',
    averageTicket: 'Average ticket',
    averageStay: 'Average stay',
    lastVisit: 'Last visit',
    firstVisit: 'First visit',
    members: 'Members',
    earned: 'Points earned',
    redeemed: 'Points redeemed',
    birthdays: 'Upcoming birthdays',
    birthdaysFoot: 'within the next {{count}} days',
    inactive: 'Inactive customers',
    inactiveFoot: 'no visit for {{count}} days',
  },
  sections: {
    spendByModule: 'Spend of identified customers',
    topCustomers: 'Top customers',
    consents: 'Consents granted',
    loyalty: 'Loyalty',
    byTier: 'By tier',
    spendByYear: 'Spend by year',
    favorites: 'Habits',
    favoriteOutlet: 'Favourite outlet',
    topProducts: 'Favourite products',
    recentStays: 'Recent stays',
    recentOrders: 'Recent orders',
    timeline: 'Timeline',
    interactions: 'Contacts',
    account: 'Loyalty account',
    profile: 'Profile',
    followUps: 'To follow up',
  },
  columns: {
    year: 'Year',
    amount: 'Amount',
    product: 'Product',
    quantity: 'Quantity',
    reference: 'Reference',
    resource: 'Unit',
    arrival: 'Arrival',
    departure: 'Departure',
    nights: 'Nights',
    total: 'Total',
    outlet: 'Outlet',
    date: 'Date',
    status: 'Status',
    channel: 'Channel',
    granted: 'Granted',
    kind: 'Kind',
    context: 'Context',
    outcome: 'Outcome',
    by: 'By',
    points: 'Points',
    type: 'Type',
    reason: 'Reason',
    source: 'Source',
  },
  detail: {
    subtitle: '360° view: every sale counted once, accommodation excluding the folio.',
    openRecord: 'Open the record',
    noSpend: 'No spend recorded.',
    noStays: 'No stay.',
    noOrders: 'No linked order.',
  },
  timeline: {
    kinds: {
      STAY: 'Stay',
      ORDER: 'Order',
      PAYMENT: 'Payment',
      LOYALTY: 'Loyalty',
      INTERACTION: 'Contact',
      CONSENT: 'Consent',
    },
    loadMore: 'Earlier events',
    empty: 'No event.',
  },
  loyalty: {
    title: 'Loyalty',
    subtitle: 'Points and tiers programme: earning rule, point value, benefits.',
    program: 'Programme',
    noProgram: 'No loyalty programme',
    noProgramBody:
      'Create the programme: points per sale step, a redemption value, tiers and their benefits. Nothing is credited before the start date.',
    inactiveNotice: 'The programme is inactive: no sale earns points.',
    balance: 'Balance',
    points_one: '{{count}} point',
    points_other: '{{count}} points',
    tier: 'Tier',
    noTier: 'No tier',
    nextTier: 'Next tier: {{name}} in {{count}} points',
    topTier: 'Highest tier reached',
    benefits: 'Benefits',
    balanceValue: 'Balance value',
    earnedTotal: 'Earned to date',
    redeemedTotal: 'Redeemed to date',
    transactions: 'Points ledger',
    noTransactions: 'No entry.',
    adjust: 'Adjust points',
    adjustTitle: 'Credit or debit points',
    adjustHint: 'A negative number debits. The reason is required and audited.',
    adjustPoints: 'Points',
    adjustReason: 'Reason',
    adjusted: 'Points adjusted: new balance {{balance}}.',
    redeem: 'Redeem points',
    redeemTitle: 'Redeem points',
    redeemHint: 'The debit is recorded; the discount is applied with the usual tools.',
    redeemPoints: 'Points to redeem',
    redeemed: 'Points redeemed: new balance {{balance}}.',
    types: { EARN: 'Earned', REDEEM: 'Redeemed', ADJUST: 'Adjustment', REVERSAL: 'Reversal' },
    basis: { LIFETIME: 'Lifetime', ROLLING: 'Rolling window' },
    fields: {
      name: 'Programme name',
      isActive: 'Programme active',
      isActiveHint: 'When inactive, no sale earns points.',
      startsOn: 'Start date',
      startsOnHint: 'Nothing is credited for an earlier sale.',
      pointsPerStep: 'Points per step',
      stepAmount: 'Step amount',
      pointValue: 'Point value',
      pointValueHint: 'Amount deducted per point redeemed at the till.',
      earnOnHotel: 'Stays earn points',
      earnOnPos: 'Orders earn points',
      includeCompanies: 'Companies earn points',
      tierBasis: 'Tier basis',
      tierWindowMonths: 'Window (months)',
      tiers: 'Tiers',
      tierCode: 'Code',
      tierName: 'Name',
      tierMinPoints: 'Threshold (points)',
      tierBenefits: 'Benefits (one per line)',
      addTier: 'Add a tier',
      removeTier: 'Remove',
      summary: '{{points}} point(s) per {{step}} step · 1 point = {{value}}',
    },
    save: 'Save the programme',
    saved: 'Programme saved.',
    orderRedeem: {
      title: 'Loyalty points',
      available: 'Balance: {{points}} points ({{value}})',
      points: 'Points to redeem',
      apply: 'Apply the discount',
      applied: '“Loyalty” discount of {{amount}} applied.',
      alreadyDiscounted: 'The order already carries a discount.',
      noProgram: 'No active programme.',
    },
  },
  segments: {
    title: 'Segments',
    subtitle: 'Declarative criteria, headcount computed on read, action list in one click.',
    new: 'New segment',
    edit: 'Edit segment',
    name: 'Name',
    description: 'Description',
    active: 'Active',
    members: 'Members',
    membersCount_one: '{{count}} customer',
    membersCount_other: '{{count}} customers',
    preview: 'Estimated headcount: {{count}}',
    save: 'Save',
    saved: 'Segment saved.',
    delete: 'Delete',
    deleteTitle: 'Delete this segment?',
    deleteBody: 'Customers are untouched: only the criterion disappears.',
    deleted: 'Segment deleted.',
    empty: 'No segment. Create one to target regulars, companies or inactive customers.',
    openList: 'View customers',
    followUp: 'Follow up',
    criteria: {
      title: 'Criteria (cumulative)',
      kinds: 'Kind',
      tags: 'Tags (comma-separated)',
      tierCodes: 'Tiers (codes, comma-separated)',
      minVisits: 'Minimum visits',
      minSpend: 'Minimum spend',
      periodMonths: 'Over the last (months)',
      lastVisitBefore: 'Last visit before',
      lastVisitAfter: 'Last visit after',
      inactiveDays: 'Inactive for (days)',
      birthdayMonths: 'Birthday months (1 → 12, comma-separated)',
      consent: 'Consent',
      consentAny: 'Any',
      consentGranted: 'Granted for {{channel}}',
      consentDenied: 'Missing or revoked for {{channel}}',
      modules: 'Has visited',
      hotel: 'Accommodation',
      pos: 'Outlets',
    },
  },
  followUps: {
    title: 'Follow-ups',
    subtitle: 'Action lists: whom to contact, on which channel, with which message.',
    kinds: {
      BIRTHDAYS: 'Birthdays',
      INACTIVE: 'Inactive',
      NO_CONSENT: 'No consent',
      SEGMENT: 'Segment',
    },
    segment: 'Segment',
    pickSegment: 'Pick a segment',
    columns: {
      customer: 'Customer',
      date: 'Date',
      lastVisit: 'Last visit',
      spend: 'Spend',
      loyalty: 'Loyalty',
      consents: 'Consents',
      lastContact: 'Last contact',
      actions: 'Actions',
    },
    whatsapp: 'WhatsApp',
    call: 'Call',
    email: 'E-mail',
    log: 'Log',
    empty: 'Nobody to follow up in this list.',
    template: 'Suggested message',
    noTemplate: 'No active template for this context: add one in the settings.',
    consentMissing: 'No consent for this channel',
    total_one: '{{count}} customer',
    total_other: '{{count}} customers',
  },
  interactions: {
    title: 'Contacts',
    log: 'Log a contact',
    logTitle: 'Log a contact',
    kind: 'Kind',
    context: 'Context',
    subject: 'Subject',
    body: 'Details',
    outcome: 'Outcome',
    empty: 'No contact logged.',
    saved: 'Contact logged.',
    kinds: {
      CALL: 'Call',
      WHATSAPP: 'WhatsApp',
      EMAIL: 'E-mail',
      SMS: 'SMS',
      VISIT: 'Visit',
      NOTE: 'Note',
      OTHER: 'Other',
    },
    contexts: {
      BIRTHDAY: 'Birthday',
      INACTIVE: 'Inactive follow-up',
      SEGMENT: 'Segment',
      MANUAL: 'Manual',
      SERVICE: 'Service',
    },
  },
  messages: {
    send: 'Send an e-mail',
    title: 'Send an e-mail',
    template: 'Template',
    freeText: 'Free text',
    subject: 'Subject',
    body: 'Message',
    hint: 'Variables: {{prenom}}, {{nom}}, {{nom_complet}}, {{points}}, {{palier}}, {{etablissement}}, {{derniere_visite}}.',
    sent: 'E-mail sent to {{to}}.',
    notSent: 'E-mail not sent (mail disabled); the contact is logged anyway.',
    noEmail: 'This customer has no e-mail address.',
    consentRequired: 'This customer has not consented to e-mails.',
  },
  consents: {
    title: 'Consents',
    hint: 'No commercial contact without a recorded consent for the channel.',
    channels: { EMAIL: 'E-mail', SMS: 'SMS', WHATSAPP: 'WhatsApp', PHONE: 'Phone' },
    granted: 'Granted',
    revoked: 'Revoked',
    never: 'Not recorded',
    on: 'on {{date}}',
    grant: 'Record consent',
    revoke: 'Record withdrawal',
    recorded: 'Consent recorded.',
    sourceLabel: 'Collected',
    sources: {
      IN_PERSON: 'In person',
      PHONE: 'By phone',
      FORM: 'By form',
      IMPORT: 'Import',
      OTHER: 'Other',
    },
    history: 'Consent history',
  },
  merge: {
    action: 'Merge a duplicate',
    title: 'Merge a duplicate into this record',
    description:
      'The chosen record is absorbed: its stays, orders, invoices, payments, documents, points, consents and contacts move to this record; it is then archived. Irreversible.',
    pick: 'Record to absorb',
    pickPlaceholder: 'Search the duplicate',
    confirm: 'Merge',
    done: 'Records merged.',
    mergedInto: 'This record was merged into another one.',
    openTarget: 'Open the kept record',
  },
  duplicates: {
    title: 'Probable duplicates',
    subtitle: 'Same phone, same e-mail or same name and birth date: merge from the record to keep.',
    criterion: { PHONE: 'Phone', EMAIL: 'E-mail', NAME_BIRTHDATE: 'Name and birth date' },
    empty: 'No probable duplicate.',
    visits_one: '{{count}} visit',
    visits_other: '{{count}} visits',
    createdAt: 'Created on {{date}}',
  },
  settings: {
    title: 'CRM settings',
    subtitle: 'Birthday and inactivity windows, message templates.',
    inactiveAfterDays: 'Inactive after (days)',
    birthdayWindowDays: 'Upcoming birthdays (days)',
    save: 'Save',
    saved: 'Settings saved.',
    templates: 'Message templates',
    newTemplate: 'New template',
    editTemplate: 'Edit template',
    template: {
      code: 'Code',
      name: 'Name',
      channel: 'Channel',
      context: 'Context',
      subject: 'Subject',
      body: 'Text',
      isActive: 'Active',
    },
    channels: { ANY: 'Any channel', EMAIL: 'E-mail', WHATSAPP: 'WhatsApp', SMS: 'SMS' },
    templatesEmpty: 'No template: action lists will not suggest a message.',
    deleteTemplate: 'Delete',
    deleteTemplateTitle: 'Delete this template?',
    deleted: 'Template deleted.',
    templateSaved: 'Template saved.',
  },
  pos: {
    customer: 'Customer',
    attach: 'Attach a customer',
    change: 'Change customer',
    detach: 'Remove customer',
    none: 'No customer',
    attached: 'Customer attached.',
    detached: 'Customer removed.',
    filterCustomer: 'Customer',
    tierPoints: '{{tier}} · {{points}} pts',
    pointsOnly: '{{points}} pts',
  },
  card: { title: 'Customers', foot: 'over the period', open: 'Open the CRM' },
  channels: { ANY: 'All', EMAIL: 'E-mail', WHATSAPP: 'WhatsApp', SMS: 'SMS', PHONE: 'Phone' },
  actions: { openCustomer: 'View customer', openCrm: '360° view', openReport: 'Open the report' },
} as const;
